import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lcon-modb-snmp-ms02',
  templateUrl: './lcon-modb-snmp-ms02.component.html',
  styleUrls: ['./lcon-modb-snmp-ms02.component.css']
})
export class LconModbSnmpMs02Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
